import React, {useState} from 'react';
import styled from "styled-components";
import CommonImage, {formatImageCMSData} from "@/components/common/Image";
import {DATE_FORMAT, IMAGE_FALLBACK} from "@/constants";
import Text from "@/components/common/Text";
import {BREAKPOINTS} from "@/styles/themeSettings";
import {getCssSizeValue, getHtmlFromRedactorField} from "@/utils/utils";
import dayjs from "dayjs";
import PressButton from "@/components/Press/Button";


const Wrapper = styled(PressButton)`
	--delay: ${({ $index }) => $index / 2 || 0}s;
    position: relative;
    width: 100%;
    min-height: ${getCssSizeValue(500, BREAKPOINTS.MOBILE)};
	min-width: unset;
	border: solid 1px ${({ theme }) => theme.colors.black} !important;
	transition: background-color var(--rgr-duration) var(--ease);
	max-height: unset;
	white-space: unset;
	margin-right: 20px;
	
	span{
		position: absolute;
		inset: 0;
		height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        padding: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)} ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	}
	
	&.hover{
		background-color: ${({ theme }) => theme.colors.antiflashWhite};
	}
	
    .date{
        margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

        &:before{
            translate: 0 12.5% !important;
        }
    }
	
    .desc {
        margin-top: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
		overflow: auto;
		word-break: break-word;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .icon {
		position: absolute;
		top: 0;
		right: 0;
        --size:${getCssSizeValue(25, BREAKPOINTS.MOBILE)};
        width: var(--size);
        height: var(--size);
        //aspect-ratio: 1;
        padding: ${getCssSizeValue(5, BREAKPOINTS.MOBILE)};
        background-color: ${({theme}) => theme.colors.chilliRed};
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		margin-right: unset;
        min-height: ${getCssSizeValue(500, BREAKPOINTS.TABLET)};
        .icon {
            --size:${getCssSizeValue(40, BREAKPOINTS.TABLET)};
            padding: ${getCssSizeValue(8, BREAKPOINTS.TABLET)};
        }
    }
	

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        min-height: ${getCssSizeValue(600, BREAKPOINTS.DESKTOP)};
		span{
            padding: ${getCssSizeValue(32, BREAKPOINTS.DESKTOP)} ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
		}
        .date{
            margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.DESKTOP)};
            &:before{
                translate: 0 10% !important;
            }
        }
		
        .desc {
            margin-top: ${getCssSizeValue(20, BREAKPOINTS.DESKTOP)};
        }
		
        .icon {
            --size:${getCssSizeValue(40, BREAKPOINTS.DESKTOP)};
            padding: ${getCssSizeValue(8, BREAKPOINTS.DESKTOP)};
        }
    }
`


const Image = styled(CommonImage)`
	max-height: ${getCssSizeValue(70, BREAKPOINTS.MOBILE)};
    margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.MOBILE)};
	width: fit-content;
	height: 100%;

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape){
        max-height: ${getCssSizeValue(80, BREAKPOINTS.DESKTOP)};
        margin-bottom: ${getCssSizeValue(46, BREAKPOINTS.DESKTOP)};
    }
`


export const Skeleton = ({ className = '' , index=0,...props}) => {
	return (
		<Wrapper className={`${className} press-action loading`} $index={index} {...props}/>
	)
}


const Action = ({ data, className = '', index=0,...props }) => {
	const name = data?.name || ''
	const date = dayjs(data?.date).format(DATE_FORMAT)
	const description = getHtmlFromRedactorField(data?.description || '')
	const image = formatImageCMSData(data?.media?.logo || IMAGE_FALLBACK)
	const button = data?.button || {}
	const [hover,setHover] = useState(false)

	const handleOnPointerEnter = () => {
		setHover(true)
	}

	const handleOnPointerLeave = () => {
		setHover(false)
	}
	return (
		<Wrapper
			data={button}
			onPointerEnter={handleOnPointerEnter}
			onPointerLeave={handleOnPointerLeave}
			rotation={hover ? 90 : 45}
			className={`${className} ${hover ? 'hover' : ''} press-action`}
			$index={index}
		>
			<Image
				src={image.url}
				alt={image.alt}
				placeholder={image.placeholder}
				focalPoint={image.focalPoint}
				style={{
					aspectRatio: image.aspectRatio
				}}
			/>
			<Text className="date static square typo-strawford typo-strawford-12">
				{date}
			</Text>
			<Text className="typo-borna-87">
				{name}
			</Text>
			<Text tag="div" className="desc typo-borna-45 " dangerouslySetInnerHTML={description}/>
		</Wrapper>
	);
};

export default Action;
